import config from 'app/config';

import homeView from './home/home.view';
import errorView from './error/error.view';
import clearCacheView from './clear-cache/clear-cache.view';

export default angular
  .module(`${config.appName}.views`, [
    homeView,
    errorView,
    clearCacheView,
  ])
  .name;
